var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionmarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 82,
    height: 83,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFCD3F",
    fillRule: "evenodd",
    d: "M41 8.3A33 33 0 0 0 8.2 41.5 33 33 0 0 0 41 74.7a33 33 0 0 0 32.8-33.2A33 33 0 0 0 41 8.3ZM0 41.5C0 18.5 18.4 0 41 0s41 18.6 41 41.5S63.6 83 41 83 0 64.4 0 41.5Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFCD3F",
    d: "M38.6 25.8a5 5 0 0 1 7.2.7 5.2 5.2 0 0 1-1 7.5l-3.5 2.6a11 11 0 0 0-4.4 8.8v2.8h8.2v-2.8c0-2.2 3-3.6 4.6-4.7A13.6 13.6 0 0 0 52 21.2c-4.7-5.7-13-6.5-18.7-1.8L28 24l5.2 6.5 5.4-4.6Zm7.5 33.4c0 2.8-2.3 5.2-5.1 5.2s-5.1-2.4-5.1-5.2S38.2 54 41 54s5.1 2.3 5.1 5.2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionmarkIcon);
export default __webpack_public_path__ + "static/media/questionmark-icon.80fe42fb6153c9cf6ef00e5f5c7496f5.svg";
export { ForwardRef as ReactComponent };